import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  Grid, 
  Button, 
  Container, 
  useTheme, 
  alpha,
  CircularProgress,
  Paper
} from '@mui/material';
import { RateReview } from '@mui/icons-material';
import ReviewCard from './ReviewCard';
import { formatDistanceToNow } from 'date-fns';

const Reviews = ({ reviews = [], loading = false }) => {
  const theme = useTheme();

  return (
    <Box>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 5 }}>
          <CircularProgress sx={{ color: '#D4AF37' }} />
        </Box>
      ) : reviews.length === 0 ? (
        <Paper variant="outlined" sx={{ textAlign: 'center', py: 5, borderRadius: "20px", borderStyle: "dashed" }}>
          <Typography variant="body1" color="text.secondary">No reviews yet. Be the first to leave one!</Typography>
        </Paper>
      ) : (
        <Grid container spacing={3}>
          {reviews.map((review, index) => (
            <Grid item xs={12} md={6} key={index}>
              <ReviewCard 
                user={review.user}
                rating={review.rating}
                text={review.review}
                date={review.created_at ? formatDistanceToNow(new Date(review.created_at), { addSuffix: true }) : null}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default Reviews;
